// extracted by mini-css-extract-plugin
export var measureBox = "_d9-0";